import React from "react";
import {
  getStatusLabel,
  getStatusBadgeClass,
  getRoleLabel,
  getComplaintActionLabel,
  getComplaintKindLabel,
  COMPLAINT_KIND,
} from "../../utils/complaintHelpers";
import AttachmentList from "./AttachmentList";
import { formatWorkplaceLabel } from "../../utils/dataMappers";
import "./ComplaintCard.css";

export default function ComplaintCard({
  complaint,
  viewMode = "sent",
  onRespond,
  canRespond = false,
  onTransfer,
  canTransfer = false,
  onRequestInvestigation,
  canRequestInvestigation = false,
  onOpenInvestigation,
  canOpenInvestigation = false,
}) {
  const statusClass = getStatusBadgeClass(complaint.status);
  const entityId = complaint._backendId || complaint.id;
  const workplace =
    complaint.workplaceLabel ||
    formatWorkplaceLabel(complaint.branchName, complaint.departmentName);
  const actions = Array.isArray(complaint.actions) ? complaint.actions : [];
  const isOpen =
    complaint.status !== "Resolved" && complaint.status !== "Rejected";
  const kind = complaint.kind || COMPLAINT_KIND.COMPLAINT;
  const kindLabel = getComplaintKindLabel(kind);
  const isInquiry = kind === COMPLAINT_KIND.INQUIRY;

  return (
    <div className={`complaint-card complaint-card-${statusClass}`}>
      <div className="complaint-card-header">
        <div className="complaint-card-title-row">
          <h4 className="complaint-card-title">{complaint.title}</h4>
          <div className="complaint-card-badges">
            <span
              className={`complaint-kind-badge ${
                isInquiry ? "kind-inquiry" : "kind-complaint"
              }`}
            >
              {kindLabel}
            </span>
            <span className={`complaint-status-badge status-${statusClass}`}>
              {getStatusLabel(complaint.status)}
            </span>
          </div>
        </div>
        <div className="complaint-card-meta">
          {viewMode === "sent" && (
            <span>
              إلى: {complaint.receiverName} (
              {getRoleLabel(complaint.receiverRole)})
            </span>
          )}
          {viewMode === "received" && (
            <span>
              من: {complaint.senderName} ({getRoleLabel(complaint.senderRole)})
            </span>
          )}
          {viewMode === "overview" && (
            <>
              <span>
                من: {complaint.senderName} ({getRoleLabel(complaint.senderRole)})
              </span>
              <span className="complaint-card-route">
                إلى: {complaint.receiverName} (
                {getRoleLabel(complaint.receiverRole)})
              </span>
            </>
          )}
          {complaint.jobTitle ? (
            <span className="complaint-card-job">{complaint.jobTitle}</span>
          ) : null}
          {workplace ? (
            <span className="complaint-card-workplace">{workplace}</span>
          ) : null}
          <span>
            {new Date(complaint.createdAt).toLocaleDateString("ar-EG", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>
      </div>

      <p className="complaint-card-description">{complaint.description}</p>

      {entityId && (
        <AttachmentList
          entityType="complaint"
          entityId={entityId}
          showDelete={viewMode === "sent"}
          compact
        />
      )}

      {actions.length > 0 && (
        <div className="complaint-card-history">
          {actions.map((entry) => (
            <div
              key={entry.id}
              className={`complaint-history-item action-${String(entry.action).toLowerCase()}`}
            >
              <div className="complaint-history-header">
                <span className="complaint-history-action">
                  {getComplaintActionLabel(entry.action)}
                </span>
                {entry.createdAt && (
                  <span className="complaint-history-date">
                    {new Date(entry.createdAt).toLocaleDateString("ar-EG")}
                  </span>
                )}
              </div>
              {entry.notes ? (
                <p className="complaint-history-notes">{entry.notes}</p>
              ) : null}
              {entry.performedByName ? (
                <span className="complaint-history-by">
                  {entry.performedByName}
                </span>
              ) : null}
            </div>
          ))}
        </div>
      )}

      {isOpen && (canRespond || canTransfer) && (
        <div className="complaint-card-actions">
          {canRespond && onRespond && (
            <button
              className="complaint-action-btn"
              onClick={() => onRespond(complaint)}
            >
              الرد على ال{kindLabel}
            </button>
          )}
          {canTransfer && onTransfer && (
            <button
              className="complaint-action-btn secondary"
              onClick={() => onTransfer(complaint)}
            >
              تحويل ال{kindLabel}
            </button>
          )}
        </div>
      )}

      {(canRequestInvestigation || canOpenInvestigation) && (
        <div className="complaint-card-actions">
          {canRequestInvestigation && onRequestInvestigation && (
            <button
              type="button"
              className="complaint-action-btn secondary"
              onClick={() => onRequestInvestigation(complaint)}
            >
              طلب فتح تحقيق
            </button>
          )}
          {canOpenInvestigation && onOpenInvestigation && (
            <button
              type="button"
              className="complaint-action-btn"
              onClick={() => onOpenInvestigation(complaint)}
            >
              فتح تحقيق
            </button>
          )}
        </div>
      )}
    </div>
  );
}
